module.exports = __webpack_public_path__ + "static/media/points_icon.e7647be4.svg";